import React, { useEffect, useState } from "react";
import RequestHandler from "util/RequestHandler";
import InvoiceTableFilter from "../Filters/InvoiceTableFilter";
import { Table, Empty, Col, Row, Tooltip } from "antd";
import {
  OrderedListOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { ColumnHelper } from "util/TableHelper";
import { queryHelper } from "../Filters/Helper";
import CurrencyFormat from "react-currency-format";

const InvoiceList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "ÖDENMİŞ FATURALAR" });
  const [invoices, setInvoices] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [totalSuccessfulyPaidAmount, setTotalSuccessfulyPaidAmount] =
    useState("");
  const [currencyCode, setCurrencyCode] = useState(" TRY");

  useEffect(() => {
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    if (filter) {
      query = "$filter=" + filter;
    }
    RequestHandler.get(
      `/Invoice?${query}${order} &$count=true&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setInvoices({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  }, [tableDataQueryOptions]);

  useEffect(() => {
    RequestHandler.get(
      `/Invoice/GetTotalAmountOfSuccessfulyPaidInvoices`,
      false
    ).then((response) => {
      setTotalSuccessfulyPaidAmount(response.totalInvoiceAmountString);
    });
  }, []);

  const columns = [
    {
      title: "Kurum Adı",
      dataIndex: "product",
      key: "product",
      align: "left",
    },
    {
      title: "Kurum Tipi",
      dataIndex: "productType",
      key: "productType",
      align: "left",
    },
    {
      title: "Abone No",
      dataIndex: "subscriberNo",
      key: "subscriberNo",
      align: "left",
    },
    {
      title: "Fatura Tutarı",
      dataIndex: "amountString",
      key: "amount",
      align: "left",
    },
    {
      title: "Masraf",
      dataIndex: "expenseString",
      key: "expenseString",
      align: "left",
    },
    {
      title: "Komisyon",
      dataIndex: "commissionString",
      key: "commissionString",
      align: "left",
    },
    {
      title: "Toplam Tutar",
      dataIndex: "totalString",
      key: "totalString",
      align: "left",
    },
    {
      title: "Ödeme Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      align: "left",
      render: (text) => moment(text).format("L"),
    },
    {
      title: "Referans Numarası",
      dataIndex: "referenceNumber",
      key: "referenceNumber",
      align: "left",
    },
    {
      title: "Fatura Dönemi",
      dataIndex: "invoiceTerm",
      key: "invoiceTerm",
      align: "left",
    },
    {
      title: "Durum",
      dataIndex: "invoiceStatusId",
      key: "invoiceStatusId",
      align: "left",
      render: (i, row) => {
        const icon = {
          1: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
          2: {
            color: "red",
            component: <CloseCircleOutlined />,
          },
        };
        return (
          <Tooltip title={row.invoiceStatus}>
            <a style={{ fontSize: "130%", color: icon[i].color }}>
              {icon[i].component}
            </a>
          </Tooltip>
        );
      },
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setInvoices(e);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
      </Row>

      <Row>
        <Col
          xs={24}
          md={12}
          lg={18}
          style={{ fontSize: 20, marginTop: "5px" }}
        ></Col>

        <Col
          xs={24}
          md={12}
          lg={6}
          style={{ fontSize: 20, marginTop: "5px", fontWeight: "400" }}
        >
          Toplam Ödenmiş Fatura Tutarı : {totalSuccessfulyPaidAmount}
        </Col>
      </Row>

      <InvoiceTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={invoices.data}
            loading={invoices.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: invoices.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default InvoiceList;
